/**
 * Collapsible functionality for Product Pages description tabs
 *
 * This script enables collapsible sections for the description tabs on product pages.
 * - Expands the first tab (Description) by default.
 * - Collapses all other tabs (Details, Specifications, etc.).
 * - Adds a "+" button for collapsed sections and a "−" button for expanded sections.
 * - Only runs on product pages (URLs starting with "/products/").
 * - Ensures efficient and maintainable code for future updates.
 * Last Updated: [03-05-2025]
 * Author: Restobox
 */

document.addEventListener("DOMContentLoaded", function () {
    // Ensure the script runs only on product pages based on the URL
    if (!window.location.pathname.startsWith("/products/")) return;

    document.querySelectorAll(".product__description .tab-item").forEach((section, index) => {
        const header = section.querySelector("h2");
        const content = section.querySelector(".tab-content");

        if (!header || !content) return;

        // Create a toggle button
        const toggleButton = document.createElement("span");
        toggleButton.classList.add("toggle-btn");
        toggleButton.innerHTML = index === 0 ? "&#8722;" : "&#43;"; // "-" for Description, "+" for others

        // Style adjustments for header
        Object.assign(header.style, {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
            padding: "10px"
        });

        // Append toggle button to header
        header.appendChild(toggleButton);

        // Default state: Expand first tab, collapse others
        content.style.display = index === 0 ? "block" : "none";

        // Toggle functionality
        header.addEventListener("click", () => {
            const isVisible = content.style.display === "block";
            content.style.display = isVisible ? "none" : "block";
            toggleButton.innerHTML = isVisible ? "&#43;" : "&#8722;";
        });
    });
});


/**
 * Update Search Form Action in Dynamic Search Popup at header
 *
 * This script modifies the search form inside the dynamically added `#glFilter-search-popup`.
 * - When the user clicks the search button (`.header__icon--search`), a search popup is added to the `<body>` by a separate script from an embedded app script.
 * - This script waits for the popup to be inserted into the DOM.
 * - Once added, it finds the form (`<form class="gl-d-searchbox">`) inside the popup.
 * - It then updates the form’s `action` attribute from `"/search"` to `"/collections/all"`.
 * - This ensures all searches are redirected correctly.
 *
 * Last Updated: [03-05-2025]
 * Author: Restobox
 */

document.addEventListener("DOMContentLoaded", function () {
    // Select the search trigger button (summary inside details-modal)
    const searchTrigger = document.querySelector(".header__icon--search");

    if (!searchTrigger) return; // Exit if the search trigger is missing

    searchTrigger.addEventListener("click", function () {
        // Delay execution to ensure #glFilter-search-popup is appended to the body
        setTimeout(() => {
            const searchPopup = document.querySelector("#glFilter-search-popup"); // Find the dynamically added search popup
            
            if (searchPopup) {
                const searchForm = searchPopup.querySelector("form.gl-d-searchbox"); // Locate the form inside the popup
                
                // Change form action if it's not already set correctly
                if (searchForm && searchForm.action !== "/collections/all") {
                    searchForm.action = "/collections/all"; // Update the form action URL
                }
            }
        }, 200); // Short delay to ensure the popup is added to the DOM
    });
});


/**
 * Auto-expand active collection and highlight it in the filter sidebar.
 *
 * - Identifies the active collection based on the URL slug.
 * - Locates the corresponding collection button in the filter sidebar.
 * - Applies a text color change (`#5c7a3a`) to highlight the active collection.
 * - Dynamically injects CSS to enforce color change without modifying existing styles.
 *
 * How it works:
 * 1. Extracts the collection slug from the URL (`/collections/[collection-slug]`).
 * 2. Searches for a button with `data-fvalue` matching the collection slug.
 * 3. Adds an `.active-collection` class to the matching button.
 * 4. Expands the closest parent `<li>` of button closet <li>.
 * 5. Appends a CSS rule to ensure the text color is updated (`#5c7a3a`).
 *
 * Last Updated: [03-05-2025]
 * Author: Restobox
 */

document.addEventListener("DOMContentLoaded", function () {
    const MAX_RETRIES = 20; // Maximum attempts to find the collection filter
    const RETRY_INTERVAL = 200; // Time (ms) between each retry
    let retryCount = 0;

    function getActiveSlug() {
        const pathParts = window.location.pathname.split("/");
        return pathParts.length >= 3 && pathParts[1] === "collections" ? pathParts[2] : null;
    }

    function foundActiveButton() {
        const activeSlug = getActiveSlug();
        if (!activeSlug) return null;

        // Try finding a `.checked` button first
        let activeBtn = document.querySelector(`.gf-option-box button[data-fvalue="${activeSlug}"].checked`);
        if (activeBtn) return activeBtn;

        // If no `.checked` button is found, select directly by attribute match
        return document.querySelector(`.gf-option-box button[data-fvalue="${activeSlug}"]`);
    }

    function highlightActiveCollection() {
        const activeBtn = foundActiveButton();
        if (!activeBtn) return false; // No active collection found, wait for next retry

        console.log("Matching Button:", activeBtn);

        activeBtn.classList.add("active-collection"); // Add class for styling

        let parentLi = activeBtn.closest("ul")?.closest("li"); // Get parent <li>
        console.log("Parent <li>:", parentLi);
        if (parentLi) {
            parentLi.classList.remove("is-collapsed"); // Expand category
            const subCategory = parentLi.querySelector("ul");
            if (subCategory) subCategory.style.display = "block";
        }

        injectCSS(); // Apply styles
        return true;
    }

    function injectCSS() {
        if (document.querySelector("#active-collection-style")) return; // Prevent duplicate CSS injection

        const style = document.createElement("style");
        style.id = "active-collection-style";
        style.innerHTML = `
            .gf-option-block ul.gf-option-box li button.active-collection .gf-label {
                color: #5c7a3a !important;
            }
        `;
        document.head.appendChild(style);
    }

    function waitForCollectionFilter() {
        if (highlightActiveCollection() || retryCount >= MAX_RETRIES) return;
        retryCount++;
        setTimeout(waitForCollectionFilter, RETRY_INTERVAL);
    }

    waitForCollectionFilter(); // Start checking for collection filter
});
